import { FC } from "react";

interface BadgeProps {
  children: React.ReactNode;
  size: "xs" | "sm" | "md" | "lg";
  classColor: string;
}

const Badge: FC<BadgeProps> = ({ children, size, classColor }) => {
  return (
    <span
      className={`${classColor} py-[2px] px-2 border-[1px] text-${size} rounded-md font-bold text-center inputoutput`}
    >
      {children}
    </span>
  );
};

export default Badge;
